module.exports = {
      id: "personas:one-usage",
      viewBox: "0 0 32 43",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#personas:one-usage",
      toString: function () {
        return this.url;
      }
    }